import React, { useState } from "react";
import "../style/contact.css";

function Contact() {
  return (
    <>
      <div className="mainContactDiv">
        <h2 className=" text-center">Get in Touch</h2>
        <p className=" text-center">
          Feel free to drop some line to contact me
        </p>
        <br />
        <br />
        <div className=" container text-capitalize ">
          <div className=" row ">
            <div className=" col-lg-6 col-md-6 col-12 my-3">
              <h3>Feel Free To Contact</h3>
              <p>
                Hello! Have a great day. I am here to help you. If you want to
                know something or you have any suggestion then please mail me.
                Thank You.
              </p>
              <span>address : ABV-IIITM GWALIOR, MP, INDIA </span>
              <br />
              <br />
              <br />
              <span>phone no : 8295850524 </span>
              <br />
              <br />
              <br />
              <span>email address : official.shivaji007@gmail.com </span>
              <br />
              <br />
              <br />
              <span>website : {window.location.origin} </span>
              <br />
            </div>
            <div className=" col-lg-6 col-md-6 col-12 my-3">
              <MassageForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const MassageForm = () => {
  const [massagedata, setmassagedata] = useState({
    senderName: "",
    email: "",
    subject: "",
    massage: "",
  });

  const handleChange = (e) => {
    let { value, name } = e.target;
    setmassagedata((preValue) => {
      console.log(preValue, name, value);
      return {
        ...preValue,
        [name]: value,
      };
    });
  };
  const submit = (e) => {
    e.preventDefault();
    const massage = `name : ${massagedata.senderName}
         
    
                     email : ${massagedata.email}




                      ${massagedata.massage}`;
    console.log(massage);
    window.location.replace(
      `mailto:official.shivaji007@gmail.com?subject=${massagedata.subject}&body=${massage}`
    );
    setmassagedata({
      senderName: "",
      email: "",
      subject: "",
      massage: "",
    });
  };
  return (
    <>
      <form onSubmit={submit}>
        <h3>send a massage</h3>
        <br />
        <div className="form-group">
          <div className="form-group">
            <label>Name: *</label>
            <input
              type="text"
              className="form-control"
              onChange={handleChange}
              name="senderName"
              value={massagedata.senderName}
              required
            />
            <br />

            <label>Email address: *</label>
            <input
              type="email"
              className="form-control"
              name="email"
              onChange={handleChange}
              value={massagedata.email}
              required
            />
            <br />

            <label>Subject: *</label>
            <input
              type="text"
              className="form-control"
              name="subject"
              onChange={handleChange}
              value={massagedata.subject}
              required
            />
            <br />
            <label>Massage: *</label>
            <textarea
              type="text"
              className="form-control"
              name="massage"
              onChange={handleChange}
              value={massagedata.massage}
              required
            ></textarea>
            <br />
          </div>
          <button type="submit" className="btn btn-primary" name="submit">
            Send
          </button>
        </div>
      </form>
    </>
  );
};

export default Contact;
